export type BrushZoomIntent = {
  shouldZoomX: boolean;
  shouldZoomY: boolean;
};

export type LinePlotZoomDrawArea = {
  top: number;
  right: number;
  bottom: number;
  left: number;
};

export type LinePlotZoomDragMetadata = {
  xZoomPercent?: number;
  yZoomPercent?: number;
};

function clampToRange(value: number, min: number, max: number): number {
  return Math.max(min, Math.min(value, max));
}

function getZoomPercent(
  selectedPixels: number,
  totalPixels: number
): number | undefined {
  if (
    !Number.isFinite(selectedPixels) ||
    !Number.isFinite(totalPixels) ||
    selectedPixels <= 0 ||
    totalPixels <= 0
  ) {
    return undefined;
  }

  return clampToRange(Math.round((selectedPixels / totalPixels) * 100), 1, 100);
}

export function getLinePlotBrushZoomPercentages({
  drawArea,
  innerHeight,
  innerWidth,
  zoomIntent,
}: {
  drawArea: LinePlotZoomDrawArea;
  innerHeight: number;
  innerWidth: number;
  zoomIntent: BrushZoomIntent;
}): Pick<LinePlotZoomDragMetadata, 'xZoomPercent' | 'yZoomPercent'> {
  const percentages: Pick<
    LinePlotZoomDragMetadata,
    'xZoomPercent' | 'yZoomPercent'
  > = {};

  if (zoomIntent.shouldZoomX) {
    percentages.xZoomPercent = getZoomPercent(
      Math.abs(drawArea.right - drawArea.left),
      innerWidth
    );
  }

  if (zoomIntent.shouldZoomY) {
    percentages.yZoomPercent = getZoomPercent(
      Math.abs(drawArea.bottom - drawArea.top),
      innerHeight
    );
  }

  return percentages;
}
